export default {
  create: 'Создание заказа',
  cancel: 'Отмена заказа',
  restart: 'Перезапуск заказа',
  change_order: 'Изменение заказа',
  change_status: 'Изменение статуса',
  route_task: 'Курьер принял маршрутное задание',
  courier: 'Назначение курьера',
  workshop: 'Цех',
  discard: 'Списание блюда',
  remaking: 'Доготовка',
  delete_route_task: 'Удаление маршрутного задания',
  confirm_route_task: 'Подтверждение маршрутного задания',
  accept: 'Заказ принят',
  manufacture: 'Заказ поступил на производство',
  courier_ignored: 'Не проставлять курьера',
  courier_not_ignored: 'Проставлять курьера',
  restore: 'Восстановлен в "Готов"'
}